import BuyCourseLayout from './layout/BuyCourseLayout.vue'
import CourseList from '@/views/buy_course/CourseList.vue'

const buyCourseRoutes = [
  {
    path: 'buy-course',
    component: BuyCourseLayout,
    children: [
      {
        path: 'course-list',
        name: 'CourseList',
        component: CourseList,
      },
      {
        path: 'course-list/:course_uuid',
        name: 'CourseSellDetail',
        meta: {
          showFooter: false,
        },
        component: () => import('@/views/buy_course/CourseSellDetail.vue'),
      },
      {
        path: 'course-checkout',
        name: 'CourseCheckout',
        meta: {
          showFooter: false,
        },
        component: () => import('@/views/buy_course/CourseCheckout.vue'),
      },
      {
        path: 'course-summary/:status',
        name: 'CourseSummary',
        meta: {
          showFooter: false,
        },
        component: () => import('@/views/buy_course/CourseSummary.vue'),
      },
    ],
  },
]

export default buyCourseRoutes
